import {getSortedContent, ContentType} from '@client/util/contentful';

interface Announcement {
  message: string;
  order: number;
}

interface State {
  announcements: Announcement[];
}

const initialState: State = {
  announcements: [],
};

const getters = {
  announcements: (state: State): Announcement[] => state.announcements,
};

const actions = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getAnnouncements(context: any): Promise<void> {
    const announcements = await getSortedContent<Announcement>({
      contentType: ContentType.Announcement,
    });

    context.commit('setAnnouncements', announcements);
  },
};

const mutations = {
  setAnnouncements(state: State, announcements: Announcement[]): void {
    state.announcements = announcements;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
